import { createSlice } from "@reduxjs/toolkit";

export const sessionSlice = createSlice({
  name: "auth/session",
  initialState: {
    token: "",
    signedIn: false,
    expired: 0,
  },
  reducers: {
    onSignInSuccess: (state, action) => {
      state.signedIn = true;
      state.token = action.payload;
      state.expired = new Date().getTime() + 7 * 24 * 60 * 60 * 1000;
    },
    onSignOutSuccess: (state) => {
      state.signedIn = false;
      state.token = "";
      state.expired = 0;
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },
    updateToken: (state, action) => {
      state.token = action.payload;
      state.expired = new Date().getTime() + 7 * 24 * 60 * 60 * 1000;
    },
  },
});

export const { onSignInSuccess, onSignOutSuccess, setToken, updateToken } =
  sessionSlice.actions;

export default sessionSlice.reducer;
